import React, { useState } from "react";
import "../Styles/SectionAnalysis.scss";
import { Progress, Tooltip, Section, MantineProvider, } from "@mantine/core";
import dropdown from "../assets/dropdown.svg";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import Subjects from "./Subjects";
import { motion, AnimatePresence } from "framer-motion";


const SectionalAnalysis = ({ result }) => {
  const [opened, { close, open }] = useDisclosure(false);
  const [sectionOpen, setSectionOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  function sectionClickHandler() {
    setSectionOpen(!sectionOpen);
  }
  return (
    <div
      style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
      className="sectionAnalysisWrapper  "
    >
      <div className="innerdiv">
        <div>
          Overall attempt - <span style={{ fontWeight: "700" }}>50</span>
          <span>/</span>
          <span style={{ "font-size": "1rem", "line-height": "1.5rem" }}>
            100
          </span>
        </div>
        <div>
          <span style={{ fontWeight: "600" }}>Time</span> -{" "}
          <span style={{ fontWeight: "700" }}>40 mins</span>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "80%",
          margin: "auto",
          height: "2.5rem",
          borderRadius: "2rem",
          zIndex: "0",
          marginTop: "2rem",
          
        }}
        onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      >
          <Tooltip label="3 Correct" arrowOffset={1} arrowSize={8} withArrow opened={isHovered} >
        <div
          style={{
            width: "20%",
            backgroundColor: "#FE7970",
            borderTopLeftRadius: "2rem",
            borderBottomLeftRadius: "2rem",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              "background-color": "#3CB371",
              borderTopLeftRadius: "2rem",
              borderBottomLeftRadius: "2rem",
              borderTopRightRadius: "2rem",
              borderBottomRightRadius: "2rem",
            }}
          >
            &nbsp;
          </div>
        </div>
        </Tooltip>
        <Tooltip label="5 Incorrect" arrowOffset={1} arrowSize={8} withArrow opened={isHovered}>
        <div style={{ backgroundColor: "#C0C0C0", width: "40%" }}>
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "#FE7970",
              borderTopRightRadius: "2rem",
              borderBottomRightRadius: "2rem",
            }}
          >
            &nbsp;
          </div>
        </div>
        </Tooltip>
        <Tooltip label="5 Skipped" arrowOffset={1} arrowSize={8} withArrow opened={isHovered}>
        <div
          style={{
            backgroundColor: "#C0C0C0",
            width: "40%",
            borderTopRightRadius: "2rem",
            borderBottomRightRadius: "2rem",
          }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: "#C0C0C0",
              display: "flex",
              alignItems: "center",
            }}
          ></div>
        </div>
        </Tooltip>
      </div>

      <div className="types">
        <div className=" fst">
          <div style={{ backgroundColor: "#3CB371" }} className="fst1" />
          <div className="fst2">Correct</div>
        </div>
        <div className="fst">
          <div style={{ backgroundColor: "#FE7970" }} className="fst1" />
          <div className="fst2">Incorrect</div>
        </div>
        <div className="fst">
          <div style={{ backgroundColor: "#C0C0C0" }} className="fst1" />
          <div className="fst2">Skipped</div>
        </div>
      </div>
      <div
        className="togglebtn"
        style={{ cursor: "pointer" }}
        onClick={sectionClickHandler}
      >
        <div className="fst2">Sectional Analysis</div>
        <img
          loading="lazy"
          src={dropdown}
          style={{ rotate: !sectionOpen ? "0deg" : "180deg" }}
        />
      </div>
      <AnimatePresence>
        {sectionOpen && (
          <motion.div
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 10 }}
            transition={{ duration: 0.5 }}
            exit={{ opacity: 0, y: 0 }}
          >
            
            {
              
              result?.sectionalMarkings.map((temp,index)=>{
                return (

                  <Subjects temp={temp} />
                )
              })
            }
        
          
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SectionalAnalysis;
